import axios from "axios";
const ServerURL = "https://user.the-capacity.com";

const getData = async (url) => {
  try {
    let response = await fetch(`${ServerURL}/${url}`, {
      method: "GET",
      mode: "cors",
      headers: { "content-type": "application/json;charset=utf-8", Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.ok) {
      let result = await response.json();
      console.log(result);
      return result;
    } else {
      console.error(`Error fetching data: ${response.status} ${response.statusText}`);
      return null;
    }
  } catch (e) {
    console.error("Error fetching data:", e);
    return null;
  }
};

const getFile = async (url) => {
  try {
    let response = await fetch(`${ServerURL}/${url}`, {
      method: "GET",
      mode: "cors",
      headers: { "content-type": "application/json;charset=utf-8", Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.ok) {
      return response;
    } else {
      console.error(`Error fetching file: ${response.status} ${response.statusText}`);
      throw new Error(`Error fetching file: ${response.status} ${response.statusText}`);
    }
  } catch (error) {
    console.error("Error fetching file:", error);
    throw error;
  }
};

// const PostLogin = async (url, body) => {
//   // const [token, setToken] = useState("");
//   try {
//     let response = await axios.post(`${ServerURL}/${url}`, {
//       username: body.username,
//       password: body.password,
//     });
//     const token = response.data.token;
//     console.log(token);
//     localStorage.setItem("token", token);

//     const userDetails = await getData("/users/welcome");
//     localStorage.setItem("user", JSON.stringify(userDetails));
//     console.log(userDetails);

//     return response.data.token;
//   } catch (e) {
//     alert("Login Failed:" + e);
//     return null;
//   }
// };

// await axios.post("https://user.the-capacity.com/users/generate-token", {
//   username: "akshay@irbureau.com",
//   password: "irb1234",
// });

// const postData = async (url) => {
//   try {
//     let response = await axios.get(`${ServerURL}/${url}`, {
//       headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//     });
//     let result = await response.data;
//     console.log(result);
//     return result;
//   } catch (e) {
//     return null;
//   }
// };

const postData = async (url, body) => {
  console.log(JSON.stringify(body));
  try {
    let response = await axios.post(`${ServerURL}/${url}`, body, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.status === 200 || response.status === 201) {
      let result = await response.data;
      console.log(result);
      return result;
    } else {
      console.error(`Error posting data: ${response.status} ${response.statusText}`);
      return null;
    }
  } catch (e) {
    return null;
  }
};

const postFile = async (url, formData) => {
  try {
    let response = await axios.post(`${ServerURL}/${url}`, formData, {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${localStorage.getItem("token")}`, accept: "*/*" },
    });

    if (response.status === 200 || response.status === 201) {
      let result = response.data;
      console.log(result);
      return result;
    } else {
      console.error(`Error posting file: ${response.status} ${response.statusText}`);
      return null;
    }
  } catch (e) {
    console.error("Error posting file:", e);
    return null;
  }
};

const putData = async (url, body) => {
  console.log(JSON.stringify(body));
  try {
    let response = await axios.put(`${ServerURL}/${url}`, body, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.status === 200 || response.status === 204) {
      let result = await response.data;
      console.log(result);
      return result;
    } else {
      console.error(`Error updating data: ${response.status} ${response.statusText}`);
      return null;
    }
  } catch (e) {
    return null;
  }
};

const deleteData = async (url) => {
  try {
    let response = await axios.delete(`${ServerURL}/${url}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.status === 200 || response.status === 204) {
      let result = await response.data;
      console.log(result);
      return result;
    } else {
      console.error(`Error deleting data: ${response.status} ${response.statusText}`);
      return null;
    }
  } catch (e) {
    return null;
  }
};

export { getData, postData, postFile, getFile, putData, deleteData, ServerURL };

// "content-type": "multipart/form-data" } ,
